import { GatewayUserModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/users/models/outputs/gateway-user.model';
import { DisplayColumnDef } from '@tanstack/react-table';

import { UserListActionsCell } from './user-list-actions.cell';
import { UserListActionsHeader } from './user-list-actions.header';

export const UserListActionsColumn: DisplayColumnDef<
  GatewayUserModel,
  unknown
> = {
  id: 'actions',
  enableSorting: false,
  enableHiding: false,
  header: UserListActionsHeader,
  cell: UserListActionsCell,
};
